module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00417.9f914caa.jpg";